import {COUNTRY_CODES, QUERY_CACHE_KEYS} from '../../../utils/constants';
import {STANDARD_FIELD_TYPES, STANDARD_FIELD_V2_TYPES} from '@guestapp/core';

type GetResidenceCityQueryKey = {
  url?: string;
  residenceCountry?: string;
};

const getResidenceCityQueryKey = ({residenceCountry, url}: GetResidenceCityQueryKey) => {
  const isSpain = residenceCountry === COUNTRY_CODES.spain;

  if (isSpain) {
    return url
      ? [url]
      : [QUERY_CACHE_KEYS.paginatedSpanishResidenceCities, residenceCountry];
  }

  return [QUERY_CACHE_KEYS.paginatedCitiesList, residenceCountry];
};

const getIsSelectFieldType = (
  fieldType: STANDARD_FIELD_TYPES | STANDARD_FIELD_V2_TYPES,
) => {
  return (
    fieldType === STANDARD_FIELD_TYPES.select ||
    fieldType === STANDARD_FIELD_V2_TYPES.select
  );
};

export {getIsSelectFieldType, getResidenceCityQueryKey};
